import"../../chunk-SDBWQ4EE.js";const e=(o,t,n)=>{if(t&&o&&o.length!==0)for(const s of o)s[t]=n};export{e as setPropsForSlottedComponents};
